import { gql, useLazyQuery } from '@apollo/client';
import { PropsWithChildren, useEffect } from 'react';
import { Button, ButtonProps } from '~/components/button';
import { LDClient, LDFlags } from '~/providers';
import {
  Flex_FetchDashboardUrlQuery,
  Flex_FetchDashboardUrlQueryVariables,
} from '~/typings/graphql';
import { updateQueryParams } from '~/utils/redirects';
import { LegacyTrackingEvent } from '~/utils/tracking';

export const FETCH_DASHBOARD_URL = gql`
  query Flex_FetchDashboardUrl($userId: Int!) {
    user(id: $userId) {
      url: redirectUrl(app: lovebird)
    }
  }
`;
export interface DashboardButtonProps extends ButtonProps {
  track?: LegacyTrackingEvent;
  userId: number;
}

export const DashboardButton = ({
  children,
  track,
  userId,
}: PropsWithChildren<DashboardButtonProps>) => {
  const [getUrl, { loading, data }] = useLazyQuery<
    Flex_FetchDashboardUrlQuery,
    Flex_FetchDashboardUrlQueryVariables
  >(FETCH_DASHBOARD_URL, {
    fetchPolicy: 'no-cache',
    variables: { userId },
  });

  useEffect(() => {
    if (data?.user?.url) {
      let redirectionUrl = data.user.url;

      if (LDClient.variation(LDFlags.showRewardsGuidelines)) {
        redirectionUrl = updateQueryParams(redirectionUrl, { showRewardsGuidelines: true });
      }
      window.location.assign(redirectionUrl);
    }
  }, [data]);

  return (
    <Button
      mt="24px"
      mode="primary"
      loading={loading}
      onClick={() => getUrl()}
      testId="go-to-dashboard-button"
      track={track}
    >
      {children}
    </Button>
  );
};
